const BASE_URL = "https://api.mansitranslator.ru/api/";

export {BASE_URL};